import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=2e0ea86a&scoped=true"
import script from "./Tips.vue?vue&type=script&lang=js"
export * from "./Tips.vue?vue&type=script&lang=js"
import style0 from "./Tips.vue?vue&type=style&index=0&id=2e0ea86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ea86a",
  null
  
)

export default component.exports